import React from 'react';

import Button from 'components/Buttons/Button';
import { Desktop } from 'components/Responsive';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { htmlT } from 'utils/generic';

import SimpleButton from './components/SimpleButton';
import { BgImage, Illustration, Content, EmptyContainer, FullContainer, ButtonContainer, Title } from './styles';

interface Props {
  onClick: () => void;
  isUser?: boolean;
  noButton?: boolean;
}
const PaymentCardNoCard = ({ onClick, isUser, noButton }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <FullContainer>
      <EmptyContainer>
        <BgImage className={isUser ? 'user' : ''}>
          <Content>
            {isUser ? <Title>{t('payment.noCard.userTitle')}</Title> : null}
            {htmlT(t, 'payment.noCard.text')}
          </Content>

          <Desktop>
            <Illustration alt="Card illustration" src="/images/illustration-card.png" />
          </Desktop>

          {noButton ? null : isUser ? (
            <SimpleButton onClick={onClick} label={t('payment.noCard.btnAddCard')} />
          ) : (
            <ButtonContainer>
              <Button onClick={onClick}>{t('payment.noCard.btnContinue')}</Button>
            </ButtonContainer>
          )}
        </BgImage>
      </EmptyContainer>
    </FullContainer>
  );
};

export default PaymentCardNoCard;
